import React from 'react';
import { CircularProgress, Typography } from '@mui/material';
import { useUsageLimitControllerAdminUsageLimitsQuery } from '@shared/services/apiService/apiService';

interface ConcurrentCallsCellProps {
  companyId: string;
}

export const ConcurrentCallsCell: React.FC<ConcurrentCallsCellProps> = ({ companyId }) => {
  const { data, isLoading } = useUsageLimitControllerAdminUsageLimitsQuery({ id: companyId });

  if (isLoading) {
    return <CircularProgress size={14} />;
  }

  if (!data?.concurrent) {
    return <Typography variant="body2">—</Typography>;
  }

  return (
    <Typography variant="body2">
      {data.concurrent.activeCalls} / {data.concurrent.limit}
    </Typography>
  );
};
